export const SOURCE_CODE_REPO = 'https://github.com/mui/mui-x';
export const SOURCE_GITHUB_BRANCH = 'master'; // #target-branch-reference
// Replace `master` with the new branch `vX.x` when creating the first PR on the vX.x branch
// For example, when creating v9 from v8, `master -> v8.x`
